import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import { ApiPaginationResponse } from "types/api";
import { AnnoucementType } from "types/retrieve";

import {
  GetBannerResponse,
  GetLogoResponse,
  WagerPayload,
  WagerResponseType,
} from "./type";

export const RetrieveApi = {
  async retrieveAnnoucement(page: number, size: number) {
    const { data } = await axiosRequest.post<
      ApiPaginationResponse<AnnoucementType[]>
    >(
      "/",
      payloadHelper("Announcement", null, {
        page,
        size,
      })
    );
    return data;
  },

  async retriveBanner() {
    const { data } = await axiosRequest.post<GetBannerResponse>(
      "/",
      payloadHelper("Banner", null, null)
    );
    return data;
  },

  async retriveLogo() {
    const { data } = await axiosRequest.post<GetLogoResponse>(
      "/",
      payloadHelper("Logo", null, { domain: "rrrbets.com" })
    );
    return data;
  },
  async retrieveWager(payload: WagerPayload) {
    const { data } = await axiosRequest.post<WagerResponseType>(
      "/",
      payloadHelper("Wager", payload.username, payload)
    );
    return data;
  },
};
